import moment from 'moment';
import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {
  SearchField,
  DateField,
  TextField,
  SelectField
} from 'components/Fields';

import {required, validDate} from 'utils/validators';
import {getCurrentMonthFirstDay} from 'utils/datetime';
import {SCHEDULE_TYPES, SCHEDULE_TYPES_HUMAN_VALUES} from 'ducks/tenancy';

import './styles.css';

const SCHEDULE_TYPE_OPTIONS = Object.keys(SCHEDULE_TYPES).map(key => ({
  label: SCHEDULE_TYPES_HUMAN_VALUES[key],
  value: SCHEDULE_TYPES[key]
}));

const BaseFields = ({
  xeroAccounts,
  fetchXeroTaxRates,
  openFromBookingSet,
  canCreateCreditNoteForPastMonths,
  scheduleType
}) => {
  //The default value of datePickerProps is undefined.
  //This comes from the datepicker library we use.
  let datepickerProps: any = undefined;
  const forRentSchedule = scheduleType === SCHEDULE_TYPES.RENT;

  const currentMonthFirstDay: any = getCurrentMonthFirstDay();

  if (!canCreateCreditNoteForPastMonths) {
    datepickerProps = {
      disabledDays: {before: new Date(currentMonthFirstDay)}
    };
  }

  const DatePickerWithPermissionsOverlay = ({
    children,
    onBlur,
    onFocus,
    tabIndex,
    month // month here is the first day of the current selected month
  }: any) => {
    const shouldShowWarning =
      !canCreateCreditNoteForPastMonths && moment(month) < currentMonthFirstDay;

    return (
      <div
        className="DayPickerInput-OverlayWrapper"
        onBlur={onBlur}
        onFocus={onFocus}
        tabIndex={tabIndex}>
        <div className="DayPickerInput-Overlay">
          {children}
          {shouldShowWarning && (
            <div className="colab-centered colab-bold ">
              You do not have the permission!
            </div>
          )}
        </div>
      </div>
    );
  };
  return (
    <div className="BaseFields">
      <FormField>
        <Label>Date</Label>
        <Field
          name="dateIssued"
          className="dateIssued"
          validate={[validDate]}
          component={DateField}
          dayPickerProps={datepickerProps}
          overlayComponent={DatePickerWithPermissionsOverlay}
        />
      </FormField>
      <FormField>
        <Label>Credit Note NO</Label>
        <Field
          name="idCounter"
          className="creditNoteNo"
          validate={[required]}
          component={TextField}
        />
      </FormField>
      {openFromBookingSet && (
        <FormField>
          <Label>Category</Label>
          <Field
            name="scheduleType"
            validate={[required]}
            component={SelectField}
            options={SCHEDULE_TYPE_OPTIONS}
          />
        </FormField>
      )}
      <FormField>
        <Label>Reference</Label>
        <Field name="reference" className="reference" component={TextField} />
      </FormField>
      <FormField>
        <Label>Account</Label>
        <Field
          name="account"
          className="account"
          validate={[required]}
          component={SearchField}
          {...{options: xeroAccounts}}
          onChange={(opt: any) => fetchXeroTaxRates(opt.accountClass)}
        />
      </FormField>
      {forRentSchedule && (
        <React.Fragment>
          <FormField>
            <Label>Rent start</Label>
            <Field
              name="rentStart"
              className="rentStart"
              validate={[validDate]}
              component={DateField}
              dayPickerProps={datepickerProps}
              overlayComponent={DatePickerWithPermissionsOverlay}
            />
          </FormField>
          <FormField>
            <Label>Rent end</Label>
            <Field
              name="rentEnd"
              className="rentEnd"
              validate={[validDate]}
              component={DateField}
            />
          </FormField>
        </React.Fragment>
      )}
    </div>
  );
};

export default BaseFields;
